module.exports = __webpack_public_path__ + "img/triangle-left.39959592.webp";